import { Injectable } from '@angular/core';
import { CepDataService } from './cep-data.service';
import { HandlerService } from "../comunicator-native/handler/handler";
import { CepModel } from "./model/cep.model";
import { Data } from '../../model/error-data';

@Injectable({
  providedIn: 'root'
})
export class CepDataMobileService implements CepDataService {

  constructor(private handlerService: HandlerService) {}

  public getCep(cepId: string): Promise<CepModel | undefined> {
    const relCaronte = 'aberturaconta-consulta-enderecos';
    const dataCaronte = { cep: cepId.toString() };

    return this.handlerService.caronteCommunicator(relCaronte, null, null, false, dataCaronte).then((response: any) => {
      if (response?.data) {
        // Caso de sucesso: retorna o modelo de CEP
        console.log("response?.data", response?.data)
        return this._buildCepModel(response.data);
      } else if (response?.errorData?.messages) {
        console.log("response?.errorData?.data?.messages", response?.errorData)

        // Caso de erro: trata o campo `messages` dentro de `errorData.data`
        return this._buildCepModelFromError(response.errorData.messages);
      } else {
        console.log("caiu no else", response?.data)

        // Caso nenhum dado seja retornado
        return Promise.resolve(undefined);
      }
    });
  }
  
  private _buildCepModel(data: any): CepModel {
    return {
      postal_code: data.cep,
      street_type: data.tipoLogradouro,
      street: data.logradouro,
      district: data.bairro,
      city: data.cidade,
      state: data.uf,
      invalid: false,
      cepNotFound: false,
      data: undefined,
    };
  }
  
  private _buildCepModelFromError(messages: any[]): CepModel {
    const errorCode = Array.isArray(messages) && messages.length > 0 ? messages[0]?.codigo : undefined;
    
    console.log("errorCode", errorCode)

    return {
      postal_code: '',
      street_type: '',
      street: '',
      district: '',
      city: '',
      state: '',
      invalid: errorCode === 'cep_invalido', // Define como true se o código for 'cep_invalido'
      cepNotFound: errorCode === 'C.010', // Define como true se o código for 'C.010'
      data: undefined,
    };
  }
  
}